<!-- Componente para Slider web 
     --------------------------
     |                        |
     |  Esto puede ser una    |
     |  imagen y/o texto      |
     --------------------------
         o   o    o   o    o   

Parametros:
 - slideListTextos: Array que trae los elementos a mostrar, se compone de textos
 - slideListImgs:  Array que trae los elementos a mostrar, se compone de rutas de imagenes

¿Cómo usarlo?
 <slidergaleria-app :slideListTextos="listTextos"
                :slideListImgs="listImgs"
                ></slidergaleria-app>

Donde, por ejemplo: 
listTextos: ['texto1', 'texto2' ],
listImgs: ['unidad4/pantalla-5-3.png',
           'unidad4/pantalla-5-4.png']

Otras notas:
La cantidad de puntitos para el slider lo define el array más grande enviado, tal que funciona enviando diferente cantidad de imgs y textos
-->


<template>
    <v-card color="transparent" flat tile>

        <v-window v-model="onboarding">
            <v-window-item v-for="imagen in slideListImg" :key="imagen">
                <div class="btn-blue-dark btn-drag hvr">
                    <img :src="getImgUrl(imagen)" v-bind:alt="imagen">
                </div>
            </v-window-item>

        </v-window>
        <v-window v-model="onboarding">
            <v-window-item v-for="element in slideListTxt" :key="element">
                <div class="btn-blue-dark btn-drag hvr">
                    <span v-html="element"></span>
                </div>
            </v-window-item>
            <v-card-actions class="cont_buttons-slider">
                <v-item-group light v-model="onboarding" class="text-center " mandatory>
                    <v-item v-for="n in longitud" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                        <v-btn :color="vistos[n-1] ? '#36857B' : '#D3D2D2'" small class="item-button"
                            :input-value="active" icon @click="toggle">
                            <v-icon>mdi-record</v-icon>
                        </v-btn>
                    </v-item>
                </v-item-group>
            </v-card-actions>
        </v-window>
    </v-card>
</template>
<script>
    export default {
        props: {
            slideListTextos: {
                type: Array,
                required: false
            },
            slideListImgs: {
                type: Array,
                required: false
            }
        },
        data() {
            return {
                slideListTxt: [],
                slideListImg: [],
                onboarding: 0,
                longitud: 0,
                vistos: [],
            }
        },
        watch: {


            onboarding(val) {

                this.$set(this.vistos, val, true)
                self.onboarding = this.slideonboarding
                if (this.vistos.length == this.longitud) {
                    this.$emit('valueSlide', val);
                }
            }
        },
        methods: {
            getImgUrl(imagenacargar) {
                return require('../assets/' + imagenacargar)
            }
        },
        mounted() {
            var self = this
            self.slideListTxt = this.slideListTextos
            self.slideListImg = this.slideListImgs
            self.onboarding = this.slideonboarding
            // Se determina la longitud mayor
            if (self.slideListTxt.length > self.slideListImg.length) {
                self.longitud = self.slideListTxt.length
            } else {
                self.longitud = self.slideListImg.length
            }
            self.vistos = Array(self.longitud).fill(false);
            // console.log('List: ' + this.slideListImg);
        },
    }
</script>

<style lang="scss" scoped>
    // @import '../sass/helpers/variables';
    @import '../sass/globals';

    .cont_buttons-slider {
        justify-content: center;

        .item-button {
            width: 15px;
            height: 15px;
        }
    }

    .flip-item {
        position: relative;
        width: 100%;
        height: auto;
        //  border: dashed $color-secondary 2px;
        padding: 10px;

        p {
            text-align: center;
        }

        .pb {
            color: $color-secondary;
            font-family: FontBase-Bold;
        }

        @media screen and (max-width: 330px) {
            img {
                width: 150px;
            }

        }
    }
</style>